// extracted by mini-css-extract-plugin
export var label = "_do-1";
export var reminder = "_do-0";